import { render, staticRenderFns } from "./ApplicantPersonalProfile.vue?vue&type=template&id=0508e5f3&"
import script from "./ApplicantPersonalProfile.vue?vue&type=script&lang=js&"
export * from "./ApplicantPersonalProfile.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantPersonalProfile.vue?vue&type=style&index=0&id=0508e5f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports